<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="control">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if (control.hasError('required')) {
    <mat-error>Required</mat-error>
  }
  @if (control.hasError('message')) {
    <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
  }

  @if (control.hasError('invalidDateFormat')) {
    <mat-error>
      Invalid date format
    </mat-error>
  }
  @if (control.hasError('dateInPast')) {
    <mat-error>
      Date cannot be in the past
    </mat-error>
  }
  @if (control.hasError('dateTooFar')) {
    <mat-error>
      Effective date cannot exceed 60 days in the future.
    </mat-error>
  }
</mat-form-field>